document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '[data-wdg-campaign-list="1"]' ).forEach( ( section ) => {
		const grid = section.querySelector( '.campaign-list__grid' );
		const btn = section.querySelector( '.campaign-list__load-more' );
		if ( ! grid || ! btn ) {
			return;
		}

		const items = grid.querySelectorAll( '.campaign-list__card' );
		const max = parseInt( section.getAttribute( 'data-visible-count' ) || '6', 10 ) || 6;

		// PHP already hides cards beyond max; hide the button if nothing is hidden.
		if ( items.length <= max ) {
			btn.hidden = true;
			return;
		}

		// Enforce initial hidden state in case CSS resets override [hidden].
		items.forEach( ( el, i ) => {
			if ( i >= max ) {
				el.setAttribute( 'hidden', 'hidden' );
			}
		} );

		const showLess = 'Show less';
		const showMore = btn.textContent?.trim() || 'Load more';

		btn.setAttribute( 'aria-expanded', 'false' );

		btn.addEventListener( 'click', () => {
			const expanded = btn.getAttribute( 'aria-expanded' ) === 'true';
			const next = ! expanded;

			items.forEach( ( el, i ) => {
				if ( i >= max ) {
					if ( next ) {
						el.removeAttribute( 'hidden' );
					} else {
						el.setAttribute( 'hidden', 'hidden' );
					}
				}
			} );

			btn.textContent = next ? showLess : showMore;
			btn.setAttribute( 'aria-expanded', next ? 'true' : 'false' );
			section.classList.toggle( 'campaign-list--expanded', next );
		} );
	} );
} );
